import React from 'react';
import { Box, Accordion, AccordionItem, AccordionButton, AccordionPanel, Heading, AccordionIcon } from '@chakra-ui/react';
import { viewDateAndTime } from 'utils/date';
import CustomTable from 'components/Table/CustomTable';

const getTransactionLogsHeaders = () => {
    return [
        {
            text: 'Log',
            dataField: 'type',
            formatter: (value) => {
                return (
                    <>
                        { value }
                    </>
                );
            }
        },
        {
            text: 'Date And Time',
            dataField: 'dateTime',
            formatter: (value) => {
                return (
                    viewDateAndTime(value)
                );
            }
        }
    ];
};

const TransactionLogs = ({ data }) => {
    return (
        <Accordion allowToggle w={'100%'}>
            <AccordionItem defaultChecked boxShadow="base" borderRadius="md" mb={2}>
                <AccordionButton>
                    <Box as="span" flex='1' textAlign='left'>
                        <Heading size='md' fontWeight={'semibold'}>
                        Transaction Logs
                        </Heading>
                    </Box>
                    <AccordionIcon />
                </AccordionButton>
                <AccordionPanel pb={4}>
                    <CustomTable
                        showFilters={false}
                        columns={getTransactionLogsHeaders()}
                        data={data}
                    />
                </AccordionPanel>
            </AccordionItem>
        </Accordion>
    );
};

export default TransactionLogs;
